// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ChartGrid = registerClientReference(
    function() { throw new Error("Attempted to call ChartGrid() from the server but ChartGrid is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/tuvi/chart-grid.tsx",
    "ChartGrid",
);
